import React from 'react';
import PropTypes from 'prop-types';

import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import style from './shipping-service.module.less';
import FulfillmentPlannerContextShippingServiceSelector from '../../../../../components/shipping-service-selector/fulfillment-planner-context-shipping-service-selector';
import { CSWFieldId, getOrderDetailsFieldId } from '../../../../../constants/field-ids';
import { useEnableMultiPackageShipmentsOrderDetails } from '../../../../../feature-flags/hooks/use-multi-package-shipping-order-details';
import FedexHalShipmentTooltip from '../../../../../fulfillment-planner/shipping-service/fedex-hal-shipment-tooltip';
import { ServiceGroupSelector } from '../../../../../fulfillment-planner/shipping-service/service-group-selector';
import { useIsFedexHALByFulfillmentPlanId } from '../../../../../hooks/orders/use-fedex-hal-check';
import { usePickupRelayOrderInfoByFulfillmentPlanId } from '../../../../../hooks/orders/use-pickup-relay-order-check';
import PickupRelayTooltip from '../../../../customer-recipient-widget/pickup-relay-tooltip';
import { ShippingServiceLabel } from '../../../shared-field-labels/shared-field-labels';
import LabeledField from '../labeled-field';
import { LabeledFieldWithButton } from '../labeled-field-with-button';

const fieldId = getOrderDetailsFieldId(CSWFieldId.ShippingService);

const ShippingService = ({ fulfillmentPlanId }) => {
  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const isPickupRelayOrder = usePickupRelayOrderInfoByFulfillmentPlanId(fulfillmentPlanId) !== null;
  const enableMultiPackageShipmentsOrderDetails = useEnableMultiPackageShipmentsOrderDetails();

  if (enableMultiPackageShipmentsOrderDetails) {
    return (
      <LabeledFieldWithButton
        button={<ServiceGroupSelector />}
        label={
          <div className={style['label-and-tooltip-container']}>
            {ShippingServiceLabel}
            {isFedexHalShipment ? (
              <FedexHalShipmentTooltip iconClassName={style.icon} iconContainerClassName={style['icon-container']} />
            ) : null}
            {isPickupRelayOrder ? (
              <PickupRelayTooltip
                iconClassName={style.icon}
                isShippingServiceInstance
                tooltipTargetWrapperClassName={style['tooltip-target']}
              />
            ) : null}
          </div>
        }
      >
        <FulfillmentPlannerContextShippingServiceSelector
          dropdownMenuShouldHaveWidthOfButton
          dropdownMenuType={DropdownMenuType.ComboBox}
          fulfillmentPlanId={fulfillmentPlanId}
          id={fieldId}
          isSearchable
          showBestWayToShip
        />
      </LabeledFieldWithButton>
    );
  }

  return (
    <LabeledField
      button={<ServiceGroupSelector />}
      label={
        <div className={style['label-and-tooltip-container']}>
          {ShippingServiceLabel}
          {isFedexHalShipment ? (
            <FedexHalShipmentTooltip iconClassName={style.icon} iconContainerClassName={style['icon-container']} />
          ) : null}
          {isPickupRelayOrder ? (
            <PickupRelayTooltip
              iconClassName={style.icon}
              isShippingServiceInstance
              tooltipTargetWrapperClassName={style['tooltip-target']}
            />
          ) : null}
        </div>
      }
      labelFor={fieldId}
    >
      <FulfillmentPlannerContextShippingServiceSelector
        dropdownMenuShouldHaveWidthOfButton
        dropdownMenuType={DropdownMenuType.ComboBox}
        fulfillmentPlanId={fulfillmentPlanId}
        id={fieldId}
        isSearchable
        showBestWayToShip
      />
    </LabeledField>
  );
};

export default ShippingService;

ShippingService.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
